import { render } from "./WxCode.vue?vue&type=template&id=c7b4411a&scoped=true"
import script from "./WxCode.vue?vue&type=script&lang=js"
export * from "./WxCode.vue?vue&type=script&lang=js"

import "./WxCode.vue?vue&type=style&index=0&id=c7b4411a&scoped=true&lang=css"

import exportComponent from "/Users/Shared/Previously Relocated Items/Security/data/www/solo/CyReport/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7b4411a"]])

export default __exports__